import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
let middleware = applyMiddleware(thunk);
export default createStore(rootReducer, middleware);